import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ darkMode }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <motion.button
      onClick={toggleLanguage}
      className={`px-3 py-2 rounded-lg font-medium transition-all duration-200 border ${
        darkMode 
          ? 'text-gray-300 hover:text-white hover:bg-white/10 border-gray-600/30 hover:border-gray-500/50' 
          : 'text-gray-600 hover:text-gray-800 hover:bg-black/10 border-gray-300/30 hover:border-gray-400/50'
      }`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={i18n.language === 'en' ? 'Switch to Arabic' : 'Switch to English'}
    >
      <span className="text-sm font-bold">
        {i18n.language === 'en' ? 'AR' : 'EN'}
      </span>
    </motion.button>
  );
};

export default LanguageToggle; 